import { StyleProp, ViewStyle } from 'react-native';

import { TransparentRow } from '../Row';
import SmallTag from '../SmallTag';

export default function CampTag({ style }: { style?: StyleProp<ViewStyle> }) {
  return (
    <TransparentRow
      style={[{ marginBottom: 5, justifyContent: 'flex-start' }, style]}
    >
      <SmallTag title="Camp" color="#F5AF76" textColor="#000" />
    </TransparentRow>
  );
}
